import { Epe } from 'app/models/epe';
import { Project } from 'app/models/project';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { ApplicationsService } from 'app/services/applications.service';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { AssociationHelper } from 'app/storage/association.storage';
import { SessionStorage } from 'app/storage/session.storage';
import { catchError, EMPTY, lastValueFrom, of } from 'rxjs';
import { SopStorage } from 'app/storage/sop.storage';

@Component({
  selector: 'meeting-form',
  templateUrl: './meeting-form.component.html',
  styleUrls: ['./meeting-form.component.scss']
})
export class MeetingFormComponent implements OnInit {

    MEETING: number = 0
    // child routes read the service type synchronously, so they render only once it is resolved
    ready: boolean = false

    project: Project = new Project()
    epe: Epe = new Epe()

    // alert variables

    showAlert: boolean = false
    alertMessage: string = ''
    alertType: Alert = Alert.SUCCESS

  constructor(
    private router: Router,
    private service: AssociationsService,
    private applicationsService: ApplicationsService,
    private helper: AssociationHelper,
    public auth: SessionStorage,
    private cache: SopStorage,
  ) {}

  async ngOnInit(){

    const project_id = this.helper.getSelectedProject()
    const epe_id = this.helper.getSelectedEpe()

    if(!project_id || !epe_id){
      this.router.navigate(['/assigned-services'])
      return
    }

    const mapApp = (app: any): any => ({
      ...(app.form_data || {}),
      ...(app.user_info || {}),
      ...app,
      id: app.user_id ?? app.id,
      application_id: app._id?.['$oid'] ?? app._id,
      sop_status: app.status,
    })

    let projects = this.cache.getProjects()
    if(!projects || !projects.some((p: any) => p.application_id == project_id)){
      const all = await lastValueFrom(
        this.applicationsService.getAll({ include_user: true }).pipe(catchError(() => of([])))
      )
      projects = (all || []).map(mapApp)
      this.cache.setProjects(projects)
    }
    this.project = projects.find((p: any) => p.application_id == project_id) ?? new Project()
    this.helper.setServiceType(this.project.application_type)

    let epes = this.cache.getEpes()
    if(!epes || !epes.some((e: any) => e.application_id == epe_id)){
      const all = await lastValueFrom(
        this.applicationsService.getAll({ type: 'epe', include_user: true }).pipe(catchError(() => of([])))
      )
      epes = (all || []).map(mapApp)
      this.cache.setEpes(epes)
    }
    this.epe = epes.find((e: any) => e.application_id == epe_id) ?? new Epe()

    const status = await lastValueFrom(
      this.service.getFormStatus(project_id, epe_id).pipe(catchError(() => of({ meeting: 1 })))
    )
    this.MEETING = (status as any)?.meeting ?? 1
    this.helper.setMeetingForm(this.MEETING)
    this.ready = true
  }

  isPss(): boolean {
    return this.helper.isPss()
  }

  goToMeetingStep(outlet: number, route: string): void{
    this.MEETING = this.helper.getMeetingForm()

    if(outlet >= this.MEETING || (route != "survey" && this.auth.isProject() && outlet + 1 >= this.MEETING)){

      this.addAlert("Please complete previous form to access this", Alert.WARNING)
      return

    }

    if(route == "survey"){
      if(this.auth.isProjectBoard() || this.auth.isCallManager() || this.auth.isAdmin()){
        this.router.navigateByUrl(`form/(meeting-form:survey-form/(survey-form:admin))`)
      }
      else if(outlet + 1 < this.MEETING){
        this.router.navigateByUrl(`form/(meeting-form:survey-form/(survey-form:summary))`)
      }
      else{
        this.router.navigateByUrl(`form/(meeting-form:survey-form)/(survey-form:survey-form)`)
      }
      return
    }

    // PSS has no final meeting: slot 5 is the closure step only
    const firstStep = this.isPss() && outlet == 4 ? 'third' : 'first'

    if(outlet + 1 < this.MEETING)
      this.router.navigateByUrl(`form/(meeting-form:meeting_${outlet+1}/(meeting_${outlet+1}:summary))`)
    else
      this.router.navigateByUrl(`form/(meeting-form:meeting_${outlet+1}/(meeting_${outlet+1}:${firstStep}))`)
  }

  getCircleState(circle: number): string{
    if(circle < this.helper.getMeetingForm())
      return 'active'
    return ''
  }

  getProgressBar(): string{
    if(this.isPss()){
      // steps: 1st meeting (1), 2nd meeting (2), advice (4), closure (5)
      const meeting = this.helper.getMeetingForm()
      if(meeting >= 5) return '100%'
      if(meeting == 4) return '66%'
      if(meeting >= 2) return '33%'
      return '0%'
    }
    switch(this.helper.getMeetingForm()-1){
      case 0:  return '0%';
      case 1:  return '25%';
      case 2:  return '50%';
      case 3:  return '75%';
      case 4:  return '100%';
      default: return '0%';
    }
  }

  addAlert(message: string, type: Alert){

    this.alertMessage = message
    this.alertType = type
    this.showAlert = true

  }
  

}
